import { SerializedStyles, css } from '@emotion/react';
import { t } from 'i18n';
import { FeeItem, formatCurrency, formatPoints } from 'shared';

import { theme } from './theme';

const styles = {
  priceListStyling: css`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-bottom: ${theme.spacing.sm};
    gap: ${theme.spacing.sm};

    > p {
      font-size: ${theme.fontSize.sm};
      margin: 0;
    }
  `,
  price: css`
    white-space: nowrap;
  `,
};

type Props = {
  prices: FeeItem[] | undefined;
  pointOfSale?: string;
  css?: SerializedStyles;
};

export const PriceItemElement = ({ label, price }: { label: string; price: string }) => {
  return (
    <div css={styles.priceListStyling}>
      <p>{label}</p>
      <p css={styles.price}>{price}</p>
    </div>
  );
};

export const PriceSummaryList = ({ prices, pointOfSale }: Props) => {
  if (!pointOfSale) return undefined;

  return (
    <>
      {prices?.map(({ label, amount, priceType }, index) => {
        const price = priceType === 'points' ? formatPoints(amount, pointOfSale) : formatCurrency(amount, pointOfSale);
        return <PriceItemElement key={index} label={t(label ?? '')} price={price} />;
      })}
    </>
  );
};
